module.exports = __webpack_public_path__ + "static/media/md-stats.77e760b4.svg";